"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectors = exports.entityReducer = exports.entityAdapter = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var lodash_1 = require("lodash");
var createEntityReducer_1 = __importDefault(require("../createEntityReducer"));
var schema_1 = require("./schema");
exports.entityAdapter = (0, toolkit_1.createEntityAdapter)({});
exports.entityReducer = (0, createEntityReducer_1.default)(schema_1.key, exports.entityAdapter);
exports.selectors = exports.entityAdapter.getSelectors(function (state) { return state[schema_1.key]; });
exports.default = (0, toolkit_1.createSlice)({
    name: schema_1.key,
    initialState: exports.entityAdapter.getInitialState({ entities: {}, ids: [] }),
    reducers: exports.entityReducer,
    extraReducers: function (builder) {
        builder.addCase('inspections/gotOne', function (state, action) {
            var entities = action.payload.entities;
            var wheelAnalysis = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(wheelAnalysis)) {
                exports.entityAdapter.upsertMany(state, wheelAnalysis);
            }
        }).addCase('inspections/gotMany', function (state, action) {
            var entities = action.payload.entities;
            var wheelAnalysis = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(wheelAnalysis)) {
                exports.entityAdapter.upsertMany(state, wheelAnalysis);
            }
        });
    },
});
//# sourceMappingURL=index.js.map